import React from 'react';
import ErrorIcon from 'components/icons/error';
import { useFormat } from 'helpers/hooks/useFormat';

interface Props {
  ctaAction?: () => void;
  classNames?: string;
}

const CartFrozen = ({ classNames, ctaAction }: Props) => {
  //i18n messages
  const { formatMessage } = useFormat({ name: 'cart' });

  return (
    <div className={classNames ?? 'rounded bg-neutral-50 p-4 text-neutral-950'}>
      <div className="flex gap-4">
        <ErrorIcon className="size-6 shrink-0 fill-neutral-950" />
        <div>
          {formatMessage({ id: 'cart.frozen', defaultMessage: 'Your cart is currently frozen' })}
          {ctaAction && (
            <>
              <button
                className="mt-2 block cursor-pointer border-b border-secondary-600 text-sm text-secondary-600 transition-colors hover:opacity-90"
                onClick={ctaAction}
              >
                {formatMessage({ id: 'cart.frozen.cta', defaultMessage: 'Unfreeze cart now' })}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CartFrozen;
